import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class ApiGatewayInterceptor implements HttpInterceptor {
  constructor() {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log(`Intercept auth at ${request.url}`);

    if (request.url.startsWith(environment.apiGatewayUrl)) {
      request = request.clone({
        setHeaders: {
          'Content-Type': 'application/json',
          'x-api-key': environment.apiGatewayKey
        }
      });
    } else if (request.url.startsWith(environment.ntApiGatewayUrl)) {
      request = request.clone({
        setHeaders: {
          'Content-Type': 'application/json',
          'x-api-key': environment.ntApiGatewayKey
        }
      });
      // adv2 and datatools are using a shared endpoint, so the url is the same.
      // We have put this extra check here for now to determine adv2 specific calls.
      // This works for now as we are only using one endpoint currently /api/adv2...
    } else if (request.url.startsWith(environment.adApiGatewayUrl) && request.url.includes('/api/adv2')) {
      request = request.clone({
        setHeaders: {
          'Content-Type': 'application/json',
          'x-api-key': environment.adApiGatewayKey
        }
      });
    } else if (request.url.startsWith(environment.dtApiGatewayUrl)) {
      request = request.clone({
        setHeaders: {
          'Content-Type': 'application/json',
          'x-api-key': environment.dtApiGatewayKey
        }
      });
    }

    return next.handle(request);
  }
}
